import type { ReactNode } from 'react';
import styles from './VehicleAssociation.module.scss';

export type DetailItem = { label: string; value: ReactNode };

export const DetailGrid = ({ items }: { items: DetailItem[] }) => (
	<dl className={`${styles.grid} mb-0`}>
		{items.map(({ label, value }) => (
			<div key={label}>
				<dt className={styles.label}>{label}</dt>
				<dd className={`${styles.value} mb-0`}>{value}</dd>
			</div>
		))}
	</dl>
);

export const StatusNote = ({ kind, children }: { kind: 'automatic' | 'manual'; children: ReactNode }) => (
	<div className={`${styles.status} ${styles[kind]}`}>
		<span aria-hidden>{kind === 'automatic' ? '✓' : '✎'}</span>
		<span>{children}</span>
	</div>
);
